// extracted by mini-css-extract-plugin
var _1 = "r6tYP";
export { _1 as "cardShadow" }
